/** Pure-literal TEXT-BEHAVIOR presets for inline style objects -- sibling of `const/style-flex-presets.ts` and
 * `const/style-size-presets.ts` (same spread-and-extend pattern). `QUAL-STYLE-FLEX-IDIOM-INLINE-001` derives its
 * inline-run matcher from these records too -- but a preset ADDED here is enforced by nothing until it is also named in
 * that rule's hand-maintained `PRESETS` list. The correction to the flat "zero scanner edits" claim, and its measured
 * cost, is spelled once at that list rather than restated on each leaf. */

/** Single-line text truncation: clip + ellipsis + no wrapping -- the standard one-line label/cell treatment. */
export const TEXT_TRUNCATE_STYLE = {
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
} as const;
